import BecomingInTheCity from "./BecomingInTheCity.JPG";
import ChainEffect from "./ChainEffect.jpg";
import MIXG from "./MIXG.jpg";
import Tagainiso from "./Tagainiso.jpg";
import Paramodernities from "./Paramodernities.jpg";
import Poem from "./Poem.jpg";
import FearKnotSublime from "./FearKnotSublime.jpg";
import AltMode from "./AltMode.png";
import Wildness from "./Wildness.jpg";

    const performanceData = [{
        "key": 0,
        "image": BecomingInTheCity,
        "title": "Becoming in the City Performance Project (2019)",
        "choreographer": "Directed and choreographed by Kota Yamazaki",
        "dancers": "Kana Anayama, Kaho Toda, Kanami Nakabayashi, Nozomi Matsuo, Nanako Matsumoto, Tomohiko Kumagai, Kota Nagaya"
    },
    {
        "key": 1,
        "image": ChainEffect,
        "title": "Chain Effect (2019)",
        "choreographer": "Choreographed by Kazuyuki Futami",
        "dancers": "Natsumi Aramata, Maika Ueda, Mayu Nakaya, Nodoka Saito, Maki Takahashi, Hikari Yokoyama, Kanako Ueno, Satsuki Endo, Yurina Fujiwara, Kanami Nakabayashi, Kohei Fujimura, Hiroto Mochizuki, Kazuyuki Futami"
    },
    {
        "key": 2,
        "image": MIXG,
        "title": "MI(X)G (2018)",
        "choreographer": "Directed by Pichet Klunchun",
        "dancers": `Choreographed and Performed by Yi-Wei Tien, Sun Phitthaya Phaefuang, Jet Leang, Jed Amihan, January Low, Nana Suzuki
        Performers: Aisling Cook, ayuko, Daiki Ishikawa, Ayaka Ono, Emi Oyama, Minasu Kai, Nami Kaigaishi, Shino Komatsu, Yuuka Koyama, Peter Golightly, Fuyu Sasaki, Ken Sasaki, Yuki Shibaike, Haruka Suzuki, Rikako Chiba, Shoko Tsutsumi, Naomi Naito, Kaori Goto, Kanami Nakabayashi, Manami Fukuoka, Yuya Honjo, Mayumu Minakawa, Mai Yokoyama, Padung Jumpan, Julaluck Eakwattanapun`
    }, 
    // {
    //     "key": 3,
    //     "image": undefined,
    //     "title": `Monodialogo (2018)`,
    //     "choreographer": `Choreographed by Kazuyuki Futami`,
    //     "dancers": `Chisato Tayasu, Rika Hino, Junko Onogi, Kanami Nakabayashi, Natsumi Aramata, Maki Takahashi, Chihiro Hattori, Yuki Kano, Hikari Yokoyama, Kanako Ueno, Rieko Yamauchi, Rie Kondo, Mayu Yamashita, Marie Guido, Mai Endo`
    // },
    {
        "key": 4,
        "image": Tagainiso,
        "title": `互イニ素 (Tagainiso)  (2017)`,
        "choreographer": `Choreographed by Naoya Aoki`,
        "dancers": `Yako Omori, Yuka Okazaki, Kyoko Oku, Riko Katagiri, Harumi Kameda, Kanako Kudo, Lala Kobayashi, ​Saeko Tada, Shiori Taremizu, Yoko Takase, Natsuko Takahashi, Kanami Nakabayashi, Yuki Nakamura, Chinatsu Horikawa, Shiori Matsuo, Mao Mita, Eri Miyakawa, Masako Washizu, Naoya Aoki`
    },
    {
        "key": 5,
        "image": undefined,
        "title": `Under the Asphalt (2017)`,
        "choreographer": `Choreographed by Abby Zbikowski`,
        "dancers": `Emily DiFranco, Rasley Goode, Nicholas Kao, D'Lonte K. Lawson, Christian Leal, Vivian Lugo, Morgan Mikes, Kanami Nakabayashi, Mario Alberto Ramirez, Hunter Sturgis`
    },
    {
        "key": 6,
        "image": Paramodernities,
        "title": `Paramodernities #3 (2017)`,
        "choreographer": `Choreographed by Netta Yerushalmy`,
        "dancers": `Camille Collins, Andrea Duong, Rasley Goode, Aminah Maddox, Morgan Mikes, Kanami Nakabayashi, Oluwaesun Samuel Olaylwala, Tabitha Pupo, Francis Rodriquez`,
        "photoCred": `Photo: Lawrence Peart, Courtesy of The University of Texas at Austin`
                   
    },
    {
        "key": 7,
        "image": Poem,
        "title": `Poem (Part 1) (2016)`,
        "choreographer": `Choreographed by Alex Ketley`,
        "dancers": `Summer Fiaschetti, Zach Khoo, D'Lonte K. Lawson, Aminah Maddox, Morganne Mazeika, Kanami Nakabayashi`,
        "photoCred": `Photo: Lawrence Peart, Courtesy of The University of Texas at Austin`
    },
    {
        "key": 8,
        "image": FearKnotSublime,
        "title": `Fear Knot Sublime (2016)`,
        "choreographer": `Choreographed by David Justin`,
        "dancers": `Lizzette Chapa, Johnny Chatman II, McKenzie Cornish, Nicholas Kao, Erin Kedzie, D'Lonte K. Lawson, Morganne Mazeika, Kanami Nakabayashi, Oluwaseun Sam Olayiwola, Cassidy Oldham, Yuriko Roby, Connor Timpe`,
        "photoCred": `Photo: Lawrence Peart, Courtesy of The University of Texas at Austin`
    },
    {
        "key": 9,
        "image": AltMode,
        "title": `ALT/MODE (2015)`,
        "choreographer": `Collaboration Kate Watson-Wallace and RYAT`,
        "dancers": `Gianina Casale, Kanami Nakabayashi, Jasmine Hearn, Danielle Currica, Haylee Nichele`
    },
    {
        "key": 10,
        "image": Wildness,
        "title": `Wildness :A Requiem for J.M. (2015)`,
        "choreographer": `Choreographed by Kate Watson-Wallace`,
        "dancers": `Gianina Casale, Emily DiFranco, Stephen Dominguez, Summer Fiascetti, Jessica Gray, Katie Gunderson, Allison Irby, Nicholas Kao, Lizeth Katz, Erin Kedzie, D'Lonte K. Lawson, Ladonna Matchett, Morganne Mazeika, Kanami Nakabayashi, Hillary Richerson, Belinda Secular, Mariana Sposito, Hunger Sturgis, Connor Timpe`,
        "photoCred": `Photo: Lawrence Peart, Courtesy of The University of Texas at Austin`
    }
]

export default performanceData;